import React, { useState } from "react";
import { connect } from "react-redux";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  ListItem,
  ListItemIcon,
} from "@material-ui/core";

import { ReactComponent as SplitwiseIcon } from "../../../assets/splitwise_icon.svg";

import { deleteSplitwiseToken } from "../../../redux/actions";

import splitwise from "../../../services/splitwise";

const SplitwiseSetup = ({ splitwiseToken, deleteSplitwiseToken }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleClick = () => {
    if (!splitwiseToken) window.location.href = splitwise.getAuthLink();
    else return setDialogOpen(true);
  };

  const handleConfirm = () => {
    deleteSplitwiseToken();
    setDialogOpen(false);
  };

  return (
    <div>
      <ListItem button onClick={handleClick}>
        <ListItemIcon>
          <SplitwiseIcon height={22} />
        </ListItemIcon>
        {splitwiseToken ? "Unlink Splitwise" : "Link Splitwise"}
      </ListItem>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Are you sure you want to unlink Splitwise?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            You'll have to relink in order to create expenses.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setDialogOpen(false)}
            color="default"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            onClick={handleConfirm}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  splitwiseToken: state.firebase.profile.splitwiseToken,
});

export default connect(mapStateToProps, { deleteSplitwiseToken })(
  SplitwiseSetup
);
